import { render, staticRenderFns } from "./CommondForm.vue?vue&type=template&id=c5d38d30"
import script from "./CommondForm.vue?vue&type=script&lang=js"
export * from "./CommondForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports